// "Was liegt hier?" lookup — chip active-state only. Tab toggle + Platz-Nr. filter come from the
// shared spot-picker_compiler.js; the lookup root carries both [data-spot-picker] and
// [data-spot-lookup]. Platz taps navigate via up-links, so no selection/CTA logic is needed here.
//
// `up` is a global in this app — do not import it.

up.compiler('[data-spot-lookup]', (root) => {
  // Mark the tapped chip active within its own group (LAGER, REGAL and PLATZ are separate parents).
  const markActive = (btn, selector) => {
    btn.parentElement.querySelectorAll(selector).forEach((b) => b.classList.toggle('is-active', b === btn))
  }
  up.on(root, 'click', '.regal-btn', (event, btn) => markActive(btn, '.regal-btn'))
  up.on(root, 'click', '.platz-btn', (event, btn) => markActive(btn, '.platz-btn'))
})
